import { CHAT_SESSION_STORAGE_KEYS } from 'utils';

const assume = (
  assumedOrgId: string,
  isAssumed: boolean,
  redirectPath?: string,
) => {
  CHAT_SESSION_STORAGE_KEYS.forEach(key => sessionStorage.removeItem(key));

  const pathname = isAssumed
    ? `/answering/switch/${assumedOrgId}?redirectPath=${redirectPath}`
    : `/answering/assume/${assumedOrgId}?redirectPath=${redirectPath}`;

  window.location.href = pathname;
};

export default assume;
